/** Shared option arrays for inspection report form fields and alert notification configuration. */

export interface OptionItem {
  label: string;
  value: string;
}

export const conditionOptions: OptionItem[] = [
  { label: 'Good', value: 'good' },
  { label: 'Needs Attention', value: 'needs_attention' },
  { label: 'Requires Service', value: 'requires_service' },
];

export const conditionWithNaOptions: OptionItem[] = [...conditionOptions, { label: 'N/A', value: 'n_a' }];

export const yesNoOptions: OptionItem[] = [
  { label: 'Yes', value: 'yes' },
  { label: 'No', value: 'no' },
];

export const hvacAgeOptions: OptionItem[] = [
  { label: '1 - 10 Years', value: '1_10' },
  { label: '11 - 15 Years', value: '11_15' },
  { label: '15+ Years', value: '15_plus' },
];

export const plumbingAgeOptions: OptionItem[] = [
  { label: 'N/A', value: 'n_a' },
  { label: '1 - 6 Years', value: '1_6' },
  { label: '6 - 9 Years', value: '6_9' },
  { label: '10 - 15 Years', value: '10_15' },
];

export const booleanOptions: OptionItem[] = [
  { label: 'Checked', value: 'true' },
  { label: 'Unchecked', value: 'false' },
];
